export default "__VITE_ASSET__BBEkoZ7$__"